import React, { Component, PropTypes } from 'react';
import Style from 'style-it';

class HoverColor extends Component {
    render() {
        return Style.it(`
      .active-hover:hover {
        color: ${this.props.color} !important;
        "text-decoration": ${this.props.textDecoration};
        background-color: ${this.props.background} !important;
        }
      .active-hover-secondary:hover {
        color: ${this.props.secondaryColor} !important;
        }
      .active-hover-three:hover {
          color: ${this.props.colorThree} !important;
      }
      .active-hover-four:hover {
          color: ${this.props.colorFour} !important;
          background-color: ${this.props.colorFourBackground} !important;
          border-color: ${this.props.colorFourBorder} !important;
      }
      .active-hover-five:focus {
          color: ${this.props.colorFive} !important;
          background-color: ${this.props.colorFiveBackground} !important;
          border-color: ${this.props.colorFiveBorder} !important;
      }`);
    }
}

HoverColor.propTypes = {
    color: PropTypes.string,
    textDecoration: PropTypes.string,
    background: PropTypes.string
};

export default HoverColor;



// WEBPACK FOOTER //
// ./src/components/widgets/HoverColor.js